import { ReactNode } from "react";

import { IComponentSize } from "@multiweb/types/react";

/**
 * Rozhraní pro měření komponent
 */
export interface IMeasuredItem {
    /** Unikátní klíč komponenty */
    key: string;
    /** Měřená kompomenta */
    component: ReactNode;
    /** Callback, který se zavolá v případě úspěšného změření kompoennty */
    onItemMeasured: (size: IComponentSize) => void;
}
